import { createFileRoute, redirect } from "@tanstack/react-router";
import { EditContent, Translations } from "@/features/consent-solutions";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/copy-and-translations/")({
  beforeLoad: async ({ context, params }) => {
    const { userDetails } = context as AuthorizedRouteContext;
    const { csId } = params;

    const isUserPermitted = checkUserPermissions(userDetails, ["COOKIE_CONSENT_TEXT_TRANSLATION_VIEW"], csId);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => (
    <EditContent>
      <Translations />
    </EditContent>
  ),
});

export { Route };
